import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { config, API_URL } from '../component/include';
import { LoadEffect } from '../component/loader';
import { Bar, Pie, Line } from 'react-chartjs-2';

import {Chart,ArcElement, registerables } from 'chart.js';

// Using standard HTML date inputs instead of react-datepicker
/* import * as XLSX from 'xlsx'; */

// Register ChartJS components

const HomeworkReports = ({ show, onClose }) => {
 /*  Chart.register(ArcElement, ...registerables) */

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [reportType, setReportType] = useState('completion');
  const [filters, setFilters] = useState({
    class_id: '',
    subject_id: '',
    start_date: null,
    end_date: null
  });
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [tableData, setTableData] = useState([]);
  
  const printRef = useRef();

  useEffect(() => {
    if (show) {
      fetchClasses();
      fetchSubjects();
    }
  }, [show]);

  const fetchClasses = async () => {
    try {
      const response = await axios.get(`${API_URL}/fetch/data/classes`, { headers: config });
      if (response.data.status === 'success') {
        setClasses(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };

  const fetchSubjects = async () => {
    try {
      const response = await axios.get(`${API_URL}/fetch/data/subjects`, { headers: config });
      if (response.data.status === 'success') {
        setSubjects(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching subjects:', error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateChange = (e, field) => {
    setFilters({ ...filters, [field]: e.target.value });
  };
  
  // Helper function to format date for input[type="date"]
  function formatDateForInput(date) {
    if (!date) return '';
    return date instanceof Date ? date.toISOString().split('T')[0] : date;
  };

  const handleReportTypeChange = (e) => {
    setReportType(e.target.value);
  };

  const generateReport = async () => {
    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const response = await axios.get(`${API_URL}/homework/statistics`, {
        params: {
          ...filters,
          report_type: reportType,
          start_date: filters.start_date ? formatDate(filters.start_date) : '',
          end_date: filters.end_date ? formatDate(filters.end_date) : ''
        },
        headers: config
      });
      
      if (response.data.status === 'success') {
        setReportData(response.data.data);
        setTableData(response.data.table_data || []);
        setSuccess('Report generated successfully');
      } else {
        setError('Failed to generate report');
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error generating report:', error);
      setError('Error generating report');
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  const displayDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  };

  const exportToExcel = () => {
    if (!tableData || tableData.length === 0) {
      setError('No data to export');
      return;
    }
 /*    
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
    
    // Generate filename with report type and date
    const fileName = `Homework_${reportType}_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
    
    XLSX.writeFile(workbook, fileName);
    setSuccess('Report exported to Excel successfully'); */
  };

  const renderCompletionChart = () => {
    if (!reportData || !reportData.completion) return null;
    
    const { completion } = reportData;
    
    const barData = {
      labels: completion.labels,
      datasets: [
        {
          label: 'Completed',
          data: completion.completed,
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1,
        },
        {
          label: 'Incomplete',
          data: completion.incomplete,
          backgroundColor: 'rgba(255, 99, 132, 0.6)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
        },
      ],
    };
    
    const pieData = {
      labels: ['Completed', 'Incomplete'],
      datasets: [
        {
          data: [
            completion.completed.reduce((a, b) => a + b, 0),
            completion.incomplete.reduce((a, b) => a + b, 0),
          ],
          backgroundColor: [
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 99, 132, 0.6)',
          ],
          borderColor: [
            'rgba(75, 192, 192, 1)',
            'rgba(255, 99, 132, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };
    
    return (
      <div className="charts-container">
        <div className="row">
          <div className="col-md-8">
            <div className="card mb-4">
              <div className="card-header">Homework Completion by {completion.groupBy}</div>
              <div className="card-body">
               {/*  <Bar 
                  data={barData} 
                  options={{
                    responsive: true,
                    scales: {
                      x: {
                        stacked: false,
                      },
                      y: {
                        stacked: false,
                        beginAtZero: true,
                      },
                    },
                  }}
                /> */}
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card mb-4">
              <div className="card-header">Overall Completion</div>
              <div className="card-body">
             {/*    <Pie 
                  data={pieData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: 'bottom',
                      },
                    },
                  }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDifficultyChart = () => {
    if (!reportData || !reportData.difficulty) return null;
    
    const { difficulty } = reportData;
    
    const barData = {
      labels: difficulty.labels,
      datasets: [
        {
          label: 'Easy',
          data: difficulty.easy,
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
        },
        {
          label: 'Medium',
          data: difficulty.medium,
          backgroundColor: 'rgba(255, 205, 86, 0.6)',
        },
        {
          label: 'Hard',
          data: difficulty.hard,
          backgroundColor: 'rgba(255, 99, 132, 0.6)',
        },
      ],
    };
    
    const pieData = {
      labels: ['Easy', 'Medium', 'Hard'],
      datasets: [
        {
          data: [
            difficulty.easy.reduce((a, b) => a + b, 0),
            difficulty.medium.reduce((a, b) => a + b, 0),
            difficulty.hard.reduce((a, b) => a + b, 0),
          ],
          backgroundColor: [
            'rgba(75, 192, 192, 0.6)',
            'rgba(255, 205, 86, 0.6)',
            'rgba(255, 99, 132, 0.6)',
          ],
          borderColor: [
            'rgba(75, 192, 192, 1)',
            'rgba(255, 205, 86, 1)',
            'rgba(255, 99, 132, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };
    
    return (
      <div className="charts-container">
        <div className="row">
          <div className="col-md-8">
            <div className="card mb-4">
              <div className="card-header">Homework Difficulty by {difficulty.groupBy}</div>
              <div className="card-body">
                <Bar 
                  data={barData} 
                  options={{
                    responsive: true,
                    scales: {
                      x: {
                        stacked: true,
                      },
                      y: {
                        stacked: true,
                        beginAtZero: true,
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card mb-4">
              <div className="card-header">Overall Difficulty Distribution</div>
              <div className="card-body">
                <Pie 
                  data={pieData}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: 'bottom',
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderTrendChart = () => {
    if (!reportData || !reportData.trend) return null;
    
    const { trend } = reportData;
    
    const lineData = {
      labels: trend.labels,
      datasets: [
        {
          label: 'Assignments',
          data: trend.assignments,
          borderColor: 'rgba(75, 192, 192, 1)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          fill: true,
          tension: 0.4,
        },
        {
          label: 'Completion Rate (%)',
          data: trend.completion_rate,
          borderColor: 'rgba(255, 99, 132, 1)',
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          fill: true,
          tension: 0.4,
          yAxisID: 'y1',
        },
      ],
    };
    
    return (
      <div className="charts-container">
        <div className="row">
          <div className="col-md-12">
            <div className="card mb-4">
              <div className="card-header">Homework Trends Over Time</div>
              <div className="card-body">
               {/*  <Line 
                  data={lineData} 
                  options={{
                    responsive: true,
                    scales: {
                      y: {
                        beginAtZero: true,
                        title: {
                          display: true,
                          text: 'Number of Assignments',
                        },
                      },
                      y1: {
                        beginAtZero: true,
                        position: 'right',
                        title: {
                          display: true,
                          text: 'Completion Rate (%)',
                        },
                        min: 0,
                        max: 100,
                        grid: {
                          drawOnChartArea: false,
                        },
                      },
                    },
                  }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderReportTable = () => {
    if (!tableData || tableData.length === 0) return null;
    
    // Get headers from the first object
    const headers = Object.keys(tableData[0]);
    
    return (
      <div className="table-responsive mt-4">
        <h5>Detailed Report Data</h5>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header.replace(/_/g, ' ').toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {headers.map((header, colIndex) => (
                  <td key={colIndex}>{row[header]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className={`modal ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }}>
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Homework Reports & Analytics</h5>
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {loading && <LoadEffect className="overlay floatLoad" />}
            
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            
            <div className="filter-section mb-4">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Report Type</label>
                    <select
                      className="form-control"
                      value={reportType}
                      onChange={handleReportTypeChange}
                    >
                      <option value="completion">Completion Status</option>
                      <option value="difficulty">Difficulty Level</option>
                      <option value="trend">Time Trend Analysis</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Class</label>
                    <select
                      className="form-control"
                      name="class_id"
                      value={filters.class_id}
                      onChange={handleFilterChange}
                    >
                      <option value="">All Classes</option>
                      {classes.map(cls => (
                        <option key={cls.id} value={cls.id}>{cls.class_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Subject</label>
                    <select
                      className="form-control"
                      name="subject_id"
                      value={filters.subject_id}
                      onChange={handleFilterChange}
                    >
                      <option value="">All Subjects</option>
                      {subjects.map(subject => (
                        <option key={subject.id} value={subject.id}>{subject.subject_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="date"
                      value={formatDateForInput(filters.start_date) || ''}
                      onChange={(e) => handleDateChange(e, 'start_date')}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>End Date</label>
                    <input
                      type="date"
                      value={formatDateForInput(filters.end_date) || ''}
                      onChange={(e) => handleDateChange(e, 'end_date')}
                      className="form-control"
                      min={formatDateForInput(filters.start_date) || ''}
                    />
                  </div>
                </div>
                <div className="col-md-6 d-flex align-items-end">
                  <button
                    type="button"
                    className="btn btn-primary mr-2"
                    onClick={generateReport}
                  >
                    <i className="fa fa-chart-bar"></i> Generate Report
                  </button>
                </div>
              </div>
            </div>
            
            <div ref={printRef}>
              {reportData && (
                <div className="report-header text-center mb-4">
                  <h3>KAYUS SCHOOL</h3>
                  <h5>HOMEWORK {reportType.toUpperCase()} REPORT</h5>
                  <p>
                    {filters.start_date && filters.end_date ? (
                      <>Period: {displayDate(filters.start_date)} - {displayDate(filters.end_date)}</>
                    ) : (
                      <>All Time</>
                    )}
                    {filters.class_id && (
                      <> | Class: {classes.find(c => c.id === parseInt(filters.class_id))?.class_name || ''}</>
                    )}
                    {filters.subject_id && (
                      <> | Subject: {subjects.find(s => s.id === parseInt(filters.subject_id))?.subject_name || ''}</>
                    )}
                  </p>
                </div>
              )}
              
              {reportType === 'completion' && renderCompletionChart()}
              {reportType === 'difficulty' && renderDifficultyChart()}
              {reportType === 'trend' && renderTrendChart()}
              
              {renderReportTable()}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
            <button 
              type="button"
              className="btn btn-success" 
              onClick={exportToExcel}
              disabled={!tableData || tableData.length === 0}
            >
              <i className="fa fa-file-excel"></i> Export to Excel
            </button>
            <button 
              type="button"
              className="btn btn-info" 
              disabled={!reportData}
            >
              <i className="fa fa-print"></i> Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeworkReports;
